import useSWR, { SWRConfig } from 'swr';
import { backgroundFetcher, isRefusal } from './errors';

// A refusal won't change on a retry, and SWR would otherwise keep asking for as long as the page
// is open. Anything else retries as usual.
const retryUnlessRefused = (error, ...rest) => {
    if (!isRefusal(error)) SWRConfig.defaultValue.onErrorRetry(error, ...rest);
};

// useSWR with backgroundFetcher and the retry rule that goes with it, for a load the page can do
// without: a label, a banner, a count. A 403 leaves the page alone and is asked once.
export const useBackgroundSWR = (key, options) => useSWR(key, backgroundFetcher, {
    onErrorRetry: retryUnlessRefused,
    ...options,
});
